export default __webpack_public_path__ + "static/media/hero_wb.ad551ac5.png";